import { Injectable } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ProjdataService {
  constructor(
    private _http: HttpClient,
  ) { }
  public data:any = {};
  setData(key: any, data: any) {
    this.data[key] = data;
  }
  getData(key: any) {
    return this.data[key];
  }

  userInfo$: any = new BehaviorSubject("");
  cartQty$: any = new BehaviorSubject("");
  showPage: boolean = false;
  sendAllMailShow: boolean = false;
  formData : any = {
    type : "",
    activeData: [],
    postData: {},
    tmplateData: [],
    message : ''
  }
}